var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame50(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 133,
    viewBox: "0 0 132 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_501_1785)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 29,
    width: 64.2845,
    height: 64.2845,
    rx: 16.0711,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1422 67.8389C63.9057 67.8389 62.7941 68.9505 62.7941 71.187V74.5352H69.4904V71.187C69.4904 68.9505 68.3788 67.8389 66.1422 67.8389Z",
    stroke: "#CC99FF",
    strokeWidth: 2.00889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1019 60.0977V66.1109C54.1019 72.1242 56.5126 74.5349 62.5259 74.5349H69.7445C75.7578 74.5349 78.1684 72.1242 78.1684 66.1109V60.0977",
    stroke: "#CC99FF",
    strokeWidth: 2.00889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1421 61.1426C68.593 61.1426 70.401 59.1471 70.1599 56.6963L69.276 47.75H63.0217L62.1243 56.6963C61.8833 59.1471 63.6913 61.1426 66.1421 61.1426Z",
    stroke: "#CC99FF",
    strokeWidth: 2.00889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5926 61.1426C77.2979 61.1426 79.28 58.9462 79.0122 56.2543L78.6372 52.5713C78.155 49.0893 76.8158 47.75 73.3069 47.75H69.2222L70.1596 57.1382C70.3873 59.348 72.3828 61.1426 74.5926 61.1426Z",
    stroke: "#CC99FF",
    strokeWidth: 2.00889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6243 61.1426C59.8341 61.1426 61.8296 59.348 62.0439 57.1382L62.3385 54.1784L62.9814 47.75H58.8966C55.3878 47.75 54.0485 49.0893 53.5664 52.5713L53.2048 56.2543C52.9369 58.9462 54.919 61.1426 57.6243 61.1426Z",
    stroke: "#CC99FF",
    strokeWidth: 2.00889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6696,
    y: 29.6696,
    width: 62.9452,
    height: 62.9452,
    rx: 15.4015,
    stroke: "#00FF66",
    strokeWidth: 1.33926,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_501_1785",
    x: 0.518497,
    y: 0.875538,
    width: 131.247,
    height: 131.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.35704
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.7408
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_501_1785"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_501_1785",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame50);
export default __webpack_public_path__ + "static/media/frame50.9c2a8349959e51fc047b6af060f904dc.svg";
export { ForwardRef as ReactComponent };